<template>
  <div class="bto-sb-modalbox" @keydown.stop.esc="close" tabindex="0">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'ModalWrapper',
    mounted() {
      this.$nextTick(() => {
        let modals = document.getElementsByClassName('bto-sb-modalbox');
        modals[modals.length - 1].focus();
      });
    },
    methods: {
      close() {
        this.$emit('close');
      },
    },
  };
</script>
